import React from 'react';

/**
 * Banner for a list screen whose fetch failed.
 *
 * The six Financials list screens all shared one habit: catch the error, log it
 * to the console, stop the spinner. The table then rendered its normal empty
 * state, so "the request was refused" and "you have no invoices" looked
 * identical — and the empty one is the reading an operator believes.
 *
 * That matters most for entity scoping. An accountant whose office has no
 * entity link is refused with a message naming the fix; swallowed, it reads as
 * an empty ledger and someone goes hunting for missing invoices.
 */
const ListLoadError = ({ message, onRetry }) => {
  if (!message) return null;
  return (
    <div
      role="alert"
      style={{
        margin: '0 0 1rem',
        padding: '0.85rem 1rem',
        border: '1px solid #f59e0b',
        borderLeft: '4px solid #b45309',
        borderRadius: '6px',
        background: '#fffbeb',
        color: '#78350f',
        fontSize: '0.9rem',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '1rem',
      }}
    >
      <span>
        <strong style={{ marginRight: '0.4rem' }}>Nothing could be loaded.</strong>
        {message}
      </span>
      {onRetry && (
        <button
          type="button"
          onClick={onRetry}
          style={{
            border: '1px solid #b45309',
            background: 'transparent',
            color: '#78350f',
            borderRadius: '4px',
            padding: '0.35rem 0.75rem',
            cursor: 'pointer',
            whiteSpace: 'nowrap',
          }}
        >
          Try again
        </button>
      )}
    </div>
  );
};

export default ListLoadError;
